export const computeIsSemrush = (isInIframe, isSemrushReferrer) => Boolean(isInIframe && isSemrushReferrer);

const precomputedIsSemrush = typeof window !== 'undefined' ? window.CE_IS_SEMRUSH_SESSION : undefined;

export const isInIframe = typeof window !== 'undefined' && window.self !== window.top;

export const isSemrushReferrer = (() => {
  if (typeof document === 'undefined') {
    return false;
  }

  try {
    const hostname = new URL(document.referrer).hostname;
    return hostname === 'semrush.com' || hostname.endsWith('.semrush.com');
  } catch {
    return false;
  }
})();

export const isSemrush =
  typeof precomputedIsSemrush === 'boolean' ? precomputedIsSemrush : computeIsSemrush(isInIframe, isSemrushReferrer);
